import React from 'react';
import { Display, Lead, Caption } from '~/components/ui/typography';
import { AccentBorder } from '~/components/ui/accent-border';

interface PageHeaderProps {
  title: string;
  description?: string;
  badge?: string;
}

export function PageHeader({ title, description, badge }: PageHeaderProps) {
  return (
    <AccentBorder variant="accent" position="bottom" as="header" className="space-y-3 pb-6">
      {badge && (
        <Caption className="text-primary">{badge}</Caption>
      )}
      <Display>{title}</Display>
      {description && (
        <Lead className="max-w-3xl">{description}</Lead>
      )}
    </AccentBorder>
  );
}